<template>
    <div class="home-container" :style="{ backgroundColor: homeImage.color ? homeImage.color : '#f5f5f5', minHeight:'100vh', ...charteVars }">
        <div class="home">
            <div class="homeImage">
                <img :src="homeResource" alt="">
            </div>
            <div class="homeText" :style="textStyle">
                <h1 v-html="processText(homeImage.text)"></h1>
            </div>
        </div>
        <div class="home-arrow" :style="launchStyle">
            <img v-if="launchImage" :src="launchImage" alt="" class="launchImage">
            <span @click="exitHomePage"><span v-html="processText(homeImage.launch_text)"></span><q-icon name="arrow_downward"></q-icon></span>
        </div>
    </div>
</template>
<script>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import { useExhibitStyle } from "../../composables/useExhibitStyle";
import { useHomeLayout } from "../../composables/useHomeLayout";
export default {
    props: ["homeImage", "exhibitIdProps"],
    setup(props, ctx) {
        let homeResource = ref();
        const route = useRoute();
        const { cssVars, load: loadCharte } = useExhibitStyle(route.params.id ?? props.exhibitIdProps);
        const charteVars = computed(() => cssVars());
        const { textStyle, launchStyle } = useHomeLayout(() => props.homeImage);
        let exhibitId = ref();
        let launchResource = ref();
        let launchImage = ref();
        const start = async () => {
            exhibitId.value = route.params.id ?? props.exhibitIdProps;
            loadCharte();
            await getHomeFile();
            await getLaunchResource();
            if(launchResource.value?.launch_image_id) await getLaunchFile();
        };

        const processText = (text) => {
            if (!text) return text;
            return text.replace(/\\n/g, '\n');
        };

        const exitHomePage = () => {
            ctx.emit("exit");
        }

        const getHomeFile = async () => {
            try {
                let name = props.homeImage.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                homeResource.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };

        

        const getLaunchFile = async () => {
            try {
                let name = launchResource.value.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                launchImage.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };
        const getLaunchResource = async ( )=>{
            try {
                let url = `${process.env.VUE_APP_BASEURL}/launchImage/${exhibitId.value}`;
                let response = await axios.get(url);
                launchResource.value = response.data[0];

            } catch (error) {
                console.log(error);
            }
        }

        onMounted(start);

        return {
            homeResource,
            exhibitId,
            exitHomePage,
            launchImage,
            launchResource,
            processText,
            charteVars,
            textStyle,
            launchStyle,
        }
    }

}
</script>
<style scoped>
/* Assurez-vous que le conteneur principal ne dépasse pas la hauteur de la fenêtre et ajoutez une couleur d'arrière-plan */
.home-container {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
}

.home {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 70vh;
    padding: 2%;
    margin-bottom: 50px;
}

.homeText {
    text-align: center;
}

.homeText h1 {
    font-size: var(--expo-title-size, 40px);
    color: var(--expo-title-color, #555);
    font-weight: var(--expo-title-weight, bold);
    font-family: var(--expo-title-font, inherit);
    margin: auto;
    white-space: pre-line;
}

.homeImage {
    max-width: 600px;
    width: 90%;
}

.homeImage img {
    display: block;
    width: 100%;
    max-height: 60vh;
    object-fit: cover;
    border-radius: 15px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.home-arrow {
    font-size: 35px;
    color: #777;
    cursor: pointer;
    text-align: center;
    animation-name: moveArrowDown;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    align-items: center;
    display: flex;
}

.home-arrow span {
    white-space: pre-line;
}

.launchImage{
    max-height: 100px;
    width: auto;
    object-fit: contain;
    background: transparent;
    margin-right: 8px;
}

@keyframes moveArrowDown {
    from {
        transform: translateY(-10px);
    }

    to {
        transform: translateY(10px);
    }
}

@media (max-height: 500px) { /* Ajuster cette valeur en fonction de vos besoins */
    .home-container {
        flex-wrap: wrap; /* Permettre aux éléments de passer à la ligne */
    }

    .homeText h1, .home-arrow span {
        font-size: smaller; /* Réduire la taille de la police pour les petits écrans */
    }

    .launchImage{
    max-height: 60px;
    width: auto;
    object-fit: contain;
    background: transparent;
    margin-right: 4px;
}
}
</style>